// Initial page load — read from current variant JSON data
window.addEventListener('DOMContentLoaded', function () {
  var currentVariantEl = document.querySelector('[data-current-variant-json]');
  if (currentVariantEl) {
    try {
      var variant = JSON.parse(currentVariantEl.textContent);
      if (variant) {
        displayOrHideCrateWarning(variant.option1, variant.option2);
      }
    } catch(e) {}
  }
});

// Variant change — works with both button and dropdown pickers
document.addEventListener('variant:change', function(evt) {
  displayOrHideCrateWarning(evt.detail.variant.option1, evt.detail.variant.option2);
});

function displayOrHideCrateWarning(medium, size) {
  var crateBox = document.getElementsByClassName('product-crate-warning')[0];
  if (!crateBox) return;

  var crateBoxStyle = crateBox.style;

  if (medium === 'MetalPrint Ready to Hang') {
    var crateLink = document.getElementsByClassName('product-crate-dynamic-price')[0];
    crateBoxStyle.display = 'flex';

    switch(size) {
      case '10x60': case '15x45': case '16x48': case '20x60':
      case '24x48': case '30x60': case '40x40': case '40x50':
        crateLink.innerHTML = '<a href="javascript:addCrateToCart(41781287977159)">Add crate to cart ($100)</a>';
        crateLink.style.display = 'contents';
        break;

      case '13x78': case '24x72': case '36x72': case '30x90':
      case '40x60': case '40x80':
        crateLink.innerHTML = '<a href="javascript:addCrateToCart(41781288009927)">Add crate to cart ($150)</a>';
        crateLink.style.display = 'contents';
        break;

      default:
        crateBoxStyle.display = 'none';
    }
  } else if (medium === 'Gallery Wrapped Canvas Ready to Hang') {
    var crateLink = document.getElementsByClassName('product-crate-dynamic-price')[0];
    crateBoxStyle.display = 'flex';

    switch(size) {
      case '40x60': case '40x80': case '30x90': case '36x72':
      case '24x72': case '13x78':
        crateLink.innerHTML = '<a href="javascript:addCrateToCart(41781288009927)">Add crate to cart ($150)</a>';
        crateLink.style.display = 'contents';
        break;

      default:
        crateBoxStyle.display = 'none';
    }
  } else {
    crateBoxStyle.display = 'none';
  }
}

function addCrateToCart(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{ quantity: 1, id: variantId }]
    })
  })
  .then(function(response) {
    if (!response.ok) throw new Error('Failed to add crate');
    alert('Crate Added to Cart.');
    location.reload();
  })
  .catch(function(error) {
    console.error('Error:', error);
  });

  return false;
}
